// Import external components refrence
import React from 'react';
import ReactDOM from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import 'reflect-metadata';
import 'typeface-roboto';
import config from 'src/config';
import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import { ConnectedRouter } from 'react-router-redux';
import * as globalActions from 'store/actions/globalActions';
// - Import app components
import Master from 'containers/master';
// import { App } from 'components/AWS'
// App css
import './styles/app.css';
/**
 * Execute startup functions
 */
import './socialEngine';
import rootSaga from 'store/sagas/rootSaga';
configureStore.runSaga(rootSaga);
// Set default data
// tslint:disable-next-line:no-empty
configureStore.store.subscribe(function () { });
// - Initialize languages
configureStore.store.dispatch(globalActions.initLocale());
// Needed for onClick
// http://stackoverflow.com/a/34015469/988941
try {
    injectTapEventPlugin();
}
catch (e) { }
var theme = createMuiTheme({
    palette: {
        primary: { main: config.theme.primaryColor },
        secondary: { main: config.theme.secondaryColor }
    }
});
var supportsHistory = 'pushState' in window.history;
ReactDOM.render(React.createElement(Provider, { store: configureStore.store },
    React.createElement(ConnectedRouter, { history: configureStore.history },
        React.createElement(MuiThemeProvider, { theme: theme },
            React.createElement(Master, null)))), document.getElementById('app'));
// registerServiceWorker()



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 416
// module chunks = 50